import {
  GET_PROGRAM_EVENT_ACTIVITIES,
  GET_PROGRAM_EVENT_ACTIVITIES_SUCCESS,
  GET_PROGRAM_EVENT_ACTIVITIES_ERROR,
  GET_PROGRAM_EVENT_ACTIVITIES_EMPTY,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetProgramEventActivities = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROGRAM_EVENT_ACTIVITIES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_EVENT_ACTIVITIES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_EVENT_ACTIVITIES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PROGRAM_EVENT_ACTIVITIES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetProgramEventActivities;
